
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	filtro: {
		pesquisar: ''
	},
	lista: [],
	statusTermoUso: null,
	listaAceites: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'META_COMBUSTIVEL_TERMO_USO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'META_COMBUSTIVEL_TERMO_USO_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'META_COMBUSTIVEL_TERMO_USO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'META_COMBUSTIVEL_TERMO_USO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};
		
		case 'META_COMBUSTIVEL_TERMO_USO_STATUS':
			return {
				...state,
				statusTermoUso: action.payload
			}
			
		case 'META_COMBUSTIVEL_TERMO_USO_ACEITE_LISTADO':
            return {
				...state,
				listaAceites: action.payload.data
			};

        default:
            return state;
    }
}
